import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=6db42ee4&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=6db42ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db42ee4",
  null
  
)

export default component.exports